<template>
  <div>
    <flow-error v-if="loadState === 'error'" name="Rebates" state="error"
      phonetext="If you have questions about the heat pump rebate program, please call us at" closepath="/heat-pump-rebate" />
    <div v-if="isLoading">
      <div class="eicproduct__page-loader">
        <img src="/wp-content/themes/gmptwentynineteen/assets/images/loader-grey.svg"
          class="eicproduct__page-loader--svg" />
      </div>
    </div>
    <router-view v-if="loadState === 'complete'"></router-view>
  </div>
</template>

<script>
import { EnvironmentConstants } from "../../../environment"
import { DumpError, ReturnToSender } from "../../../utilities";
import { GetComponentStatus } from "../../../services/statuspage";

export default {
  name: "PageHeatPumpRebate",
  components: {
  },
  data() {
    return {
      loadState: undefined,
      EnvironmentConstants,
      featureEnabled: false,
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.layout.routeloading || this.loadState === undefined;
    },
    isAdmin() {
      return !!this.$store.state.user.userinfo.isAdmin;
    },
  },
  async mounted() {
    // Wire up the close button (outside of vue)
    this.closeVueComponent();

    this.loadState = undefined;
    const status = await GetComponentStatus("Rebates");

    if (status === "operational" || this.isAdmin) {
      this.loadState = "complete";
    } else {
      this.loadState = status;
    }
  },
  methods: {
    async Logout() {
      try {
        await this.$store.dispatch("LogOut");
        this.$router.replace("/login");
      } catch (err) {
        DumpError("Logout error", err);
      }
    },

    closeVueComponent() {
      const closer = document.querySelector("#flow-close");
      if (closer) {
        closer.addEventListener("click", e => {
          ReturnToSender('/heat-pump-rebate');
        });
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>